/* ---------------------------------------------------------------------------------------------------------------------
CONTENTS INSURED JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {
    var $form = $('form.contents-insured'),
        $dummyRow = $form.find('tr.dummy-row'),
        name = $dummyRow.data('name'),
        $notice = $form.find('.notice'),
        $actions = $form.find('.actions'),
        $addNewBtn = $form.find('button[data-add-row]'),
        unsaved = false;

    $addNewBtn.on('click', function (e) {
        var $newRow = $dummyRow.clone(),
            index = $form.find('tr.item').length;

        $newRow.attr('data-index', index);

        $newRow.removeClass('dummy-row').addClass('item');

        $newRow.find('input').each(function (e) {
            var $field = $(this);
            $field.val('');
            $field.attr('name', name + "[" + index +"][" + $field.attr('name') + "]");
            $field.prop('checked', false);
        });

        if (index >= 1) {
            $newRow.find('a[data-delete-row]').attr('data-delete-row', index).show();
        }

        $newRow.show().insertBefore($actions);

        unsaved = true;
    });

    $form.on('click', 'a[data-delete-row]', function (e) {
        e.preventDefault();
        if (confirm('Are you sure you want to delete this item?')) {
            var deleteIndex = $(this).data('delete-row');
            $form.find('.item[data-index=' + deleteIndex + ']').remove();
            unsaved = true;
        }
    });

    $form.on('submit', function (e) {
        e.preventDefault();

        $.ajax({
            type: 'POST',
            url: self_storage.ajax_url,
            data: {
                'action': 'handle_contents_insured',
                'data': $(this).serialize()
            },
            dataType: "json",
            beforeSend: function () {

                $notice.empty();

                $form.block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
            },
            success: function (response) {
                if (typeof response.message !== "undefined") {
                    var type = response.error ? 'error' : 'success';
                    $notice.append('<p class="' + type +'">' + response.message +'</p>')
                }

                $form.unblock();

                unsaved = false;
            }
        });
    });


    $form.on('change', function(){ //triggers change in all input fields including text type
        unsaved = true;
    });

    function unloadPage(){
        if (unsaved){
            return "You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?";
        }
    }

    window.onbeforeunload = unloadPage;

    $addNewBtn.trigger('click');
});
